export function convertMillimetersToPixels(numberInMM: number, dpi: number): number {
  return (numberInMM * dpi) / 25.4583;
}
